var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg211Ts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 13C2 18.1419 5.40237 22.4598 10 23.665V21.5772C6.55261 20.4291 4 17.0657 4 13C4 7.96046 7.92179 4 12.6083 4C16.5839 4 20.0091 6.85004 20.9569 10.7911L20.9599 10.7899C21.0937 11.3367 21.1791 11.9037 21.2108 12.4855C21.8339 12.1732 22.5272 12 23.2493 12C25.8053 12 28 14.1696 28 17C28 19.8105 25.8359 21.9695 23.3029 21.9996V22H23V23.9953C23.0827 23.9984 23.1658 24 23.2493 24C26.9776 24 30 20.866 30 17C30 13.134 26.9776 10 23.2493 10C23.1054 10 22.9626 10.0047 22.821 10.0139C21.5661 5.38976 17.469 2 12.6083 2C6.74949 2 2 6.92487 2 13ZM17.168 16.4453L13.168 22.4453L12.1315 24H14H17.0442L13.856 28.4145L15.4773 29.5855L19.8107 23.5855L20.9558 22H19H15.8685L18.8321 17.5547L17.168 16.4453Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg211Ts);
export default __webpack_public_path__ + "static/media/211ts.bc60bc4a2389537d003cdf6836c68955.svg";
export { ForwardRef as ReactComponent };